// MUST stay first: captures + scrubs the booking token from the URL fragment before App Insights
// initializes or React renders, so the token never lands in a page-view URL, history, or Referer.
import './modules/unauthenticated/booking/bookingToken'
import { MsalProvider } from '@azure/msal-react'
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js'
import ReactDOM from 'react-dom/client'
import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from 'react-router-dom'
import { reactPlugin } from './system/appinsights/AppInsights'
import { MsalInstance } from './system/msal/MsalInstance'
import { Provider } from 'react-redux'
import store from './store'
import { UUID } from './shared/utilities/Guid'
import { BrowserSessionKey } from './shared/Constants'
import ErrorBoundary from './shared/components/errorboundary/ErrorBoundary'

import '@fontsource-variable/inter'
import '@fontsource-variable/inter/wght.css'
import '@fontsource-variable/inter/wght-italic.css'
import './index.css'
import App from './App'
;(async () => {
  //This browser session key, will be used for tracking appinsights individual session,
  //to avoid resetting session id after refresh
  const sessionKey = sessionStorage.getItem(BrowserSessionKey)
  sessionStorage.setItem(BrowserSessionKey, sessionKey || UUID())
  // Msal Instance and set active account

  const msalInstance = MsalInstance.getInstance()
  await msalInstance.initialize()
  const router = createBrowserRouter(createRoutesFromElements(<Route path="*" element={<App />} />))
  ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <ErrorBoundary>
      <AppInsightsContext.Provider value={reactPlugin}>
        <MsalProvider instance={msalInstance}>
          <Provider store={store}>
            <main>
              <RouterProvider router={router} />
            </main>
          </Provider>
        </MsalProvider>
      </AppInsightsContext.Provider>
    </ErrorBoundary>
  )
})()
